import React from 'react'
import * as Styles from './styles'

type Props = {
  children: React.ReactNode
}

const FormControl: React.FC<Props> = (props: Props) => {
  return <Styles.FormControl>{props.children}</Styles.FormControl>
}

export default FormControl
